import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/location_new/uk-web/top-tier-web.webp";
import { StaticImage } from "gatsby-plugin-image";
import Modal from "react-bootstrap/Modal";
import PopUp from "../../components/popUp";

function Mobileappukcta() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <section
        className="mobile_app_ukcta business_growth_uk p-100 text_white"
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "no-repeat",
        }}
      >
        <Container>
          <Row>
            <Col
              xs={12}
              md={10}
              lg={8}
              xl={6}
              xxl={6}
              className="offset-lg-4 offset-md-1 offset-xl-6"
            >
              <h2>
                A Top-Tier <span>Website Development Company</span> That Creates
                Inspiring Web Solutions with a Custom Approach
              </h2>
              <p>
                Unleash the flair of your brand by setting a unique identity by
                utilizing a customized strategy to build your website. That’s
                how you can provide a user-centric experience in your online
                presence. We deploy all the protocols in our services for
                website development in UK that take the user experience close to
                the actual expectation of the audience. Whether it's the
                structure of the website, the design of the web pages, or the
                overall function of the features, everything is formalized
                according to the business needs and user expectations. Even our
                web design services are based on the detailed crafting of
                multiple components considering your business objective. So, the
                final product for website development in UK not only provides
                you with a solid online presence but also acts as a branding
                tool for your business.
              </p>
              <div className="app_growth_main">
                <div className="app_growth_item">
                  <button
                    style={{ background: "#F47a14", color: "#fff" }}
                    onClick={handleShow}
                    className="border_btn"
                    aria-label="TekRevol Contact"
                  >
                    Let’s Build Your Custom Website
                  </button>
                </div>
                <div className="app_growth_item">
                  <h5>OR</h5>
                </div>
                <div className="app_growth_item">
                  <div className="app_all">
                    <div className="app_growth_img">
                      <StaticImage
                        src="../../../images/location_new/uk-mobile/get_phone_icon.webp"
                        alt="TekRevol"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={57}
                        height={57}
                      />
                    </div>
                    <div className="app_growth_num">
                      <Link to="tel:+441223926620">+441-223-926620</Link>
                    </div>
                  </div>
                </div>
              </div>
              {/* <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book Your Free Consultation Today
            </Link> */}
            </Col>
          </Row>
        </Container>
      </section>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-popup"
      >
        <div className="modal_forms">
          <PopUp setShow={setShow} />
        </div>
      </Modal>
    </>
  );
}

export default Mobileappukcta;
